
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import {} from "@/types/pantry";
export default defineComponent({
  name: "PantryFoodUsedTitleView",
  components: {
  },
  props: {
    title: {
      type: String,
      default: "",
      required: true
    },
    buttonLabel: {
      type: String,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const clickButton = () => {
      context.emit("click-button");
    }
    return {
      clickButton
    };
  }
});
